import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
    const menuBlocks = document.querySelectorAll('.hamburger-menu-block');

    menuBlocks.forEach(block => {
        const toggle = block.querySelector('.hamburger-toggle');
        const closeButton = block.querySelector('.close-button');
        const overlay = block.querySelector('.menu-overlay');
        const menuContainer = block.querySelector('.menu-container');
        const menuItems = block.querySelectorAll('.menu-item');
        const subMenuParents = block.querySelectorAll('.menu-item-has-children > a');
        let isAnimating = false;

        // Create timeline for menu animations
        const tl = gsap.timeline({
            paused: true,
            onComplete: () => { isAnimating = false; },
            onReverseComplete: () => { 
                isAnimating = false;
                overlay.style.display = 'none';
                // We'll handle submenu reset after animation
            }
        });

        // Setup the animation sequence
        tl.to(overlay, {
            display: 'block',
            opacity: 1,
            duration: 0.3,
            ease: 'power2.inOut'
        })
        .to(menuContainer, {
            right: 0,
            duration: 0.4,
            ease: 'power2.inOut'
        }, '-=0.2')
        .fromTo(block.querySelectorAll('.menu-items > .menu-item'), {
            opacity: 0,
            x: 20
        }, {
            opacity: 1,
            x: 0,
            duration: 0.4,
            stagger: 0.05,
            ease: 'power2.out'
        }, '-=0.2')
        .fromTo(block.querySelector('.menu-inner-blocks'), {
            opacity: 0,
            x: 20
        }, {
            opacity: 1,
            x: 0,
            duration: 0.4,
            ease: 'power2.out'
        }, '-=0.2')
        .set(block.querySelectorAll('.sub-menu .menu-item'), {  // Reset submenu items to visible
            opacity: 1,
            x: 0
        });

        // Toggle menu handler
        toggle.addEventListener('click', () => {
            if (isAnimating) return;
            isAnimating = true;

            const isActive = block.classList.contains('is-active');
            
            if (!isActive) {
                block.classList.add('is-active');
                toggle.setAttribute('aria-expanded', 'true');
                tl.play();
            } else {
                // Close any open submenus before closing the main menu
                const activeSubmenus = block.querySelectorAll('.sub-menu.is-active');
                if (activeSubmenus.length > 0) {
                    const submenuTl = gsap.timeline({
                        onComplete: () => {
                            block.classList.remove('is-active');
                            toggle.setAttribute('aria-expanded', 'false');
                            tl.reverse();
                            // Reset submenu states after animation
                            block.querySelectorAll('.sub-menu').forEach(submenu => {
                                submenu.classList.remove('is-active');
                                submenu.style.height = '0px';
                            });
                            block.querySelectorAll('.submenu-active').forEach(item => {
                                item.classList.remove('submenu-active');
                            });
                        }
                    });

                    activeSubmenus.forEach(submenu => {
                        submenuTl.to(submenu, {
                            height: 0,
                            duration: 0.3,
                            ease: 'power2.inOut'
                        }, 0); // The 0 makes all submenus animate simultaneously
                    });
                } else {
                    block.classList.remove('is-active');
                    toggle.setAttribute('aria-expanded', 'false');
                    tl.reverse();
                }
            }
        });

        // Close menu when clicking overlay
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                toggle.click();
            }
        });

        // Toggle submenus
        subMenuParents.forEach(parent => {
            parent.addEventListener('click', (e) => {
                e.preventDefault();
                const subMenu = parent.nextElementSibling;
                const subMenuItems = subMenu.querySelectorAll('.menu-item');
                const isActive = subMenu.classList.contains('is-active');
                parent.classList.toggle('submenu-active');

                if (!isActive) {
                    // Get initial height
                    subMenu.classList.add('is-active');
                    const height = subMenu.scrollHeight;
                    subMenu.style.height = '0px';

                    // Create timeline for submenu animation
                    const submenuTl = gsap.timeline();
                    
                    // Close menu when clicking on submenu item
                    subMenuItems.forEach(item => {
                        // Check if item has a link, if so, check if contains #
                        const link = item.querySelector('a');
                        if (link && link.href.includes('#')) {
                            // Close menu when clicking on submenu item with link to #
                            link.addEventListener('click', (e) => {
                                toggle.click();
                            });
                        }
                    });

                    // Animate height and items
                    submenuTl.to(subMenu, {
                        height: height,
                        duration: 0.3,
                        ease: 'power2.inOut',
                        onComplete: () => {
                            subMenu.style.height = 'auto';
                        }
                    })
                    .fromTo(subMenuItems, {
                        opacity: 0,
                        x: 20
                    }, {
                        opacity: 1,
                        x: 0,
                        duration: 0.3,
                        stagger: 0.05,
                        ease: 'power2.out'
                    }, '-=0.1');

                } else {
                    // Animate to zero
                    gsap.to(subMenu, {
                        height: 0,
                        duration: 0.3,
                        ease: 'power2.inOut',
                        onComplete: () => {
                            subMenu.classList.remove('is-active');
                            // Reset submenu items to initial state
                            gsap.set(subMenu.querySelectorAll('.menu-item'), {
                                clearProps: 'all'
                            });
                        }
                    });
                }
            });
        });

        // Close menu on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && block.classList.contains('is-active')) {
                toggle.click();
            }
        });

        // Add close button handler
        closeButton.addEventListener('click', () => {
            toggle.click();
        });
    });
});
